import React from 'react';
import { ArrowRight, ShieldCheck, Zap, Layers, PenTool } from 'lucide-react';
import { motion } from 'framer-motion';
export function FeaturedSection() {
  return <section className="relative py-24 bg-[#0A1628] overflow-hidden" data-id="element-111">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-112">
        <img src="https://cdn.magicpatterns.com/uploads/i2yMCyiiDWAnhFbYk4PW71/AD.jpg" alt="Industrial Facility" className="w-full h-full object-cover opacity-10" data-id="element-113" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A1628] via-[#0A1628]/95 to-[#0A1628]/90" data-id="element-114"></div>
      </div>

      <div className="max-w-[1440px] mx-auto px-6 md:px-12 relative z-10" data-id="element-115">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-116">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-117">
            <span className="text-[#0052CC] font-bold tracking-widest uppercase text-sm mb-4 block" data-id="element-118">
              Built to last
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 leading-tight" data-id="element-119">
              Extreme durability as standard
            </h2>
            <p className="text-lg text-slate-400 mb-8 leading-relaxed" data-id="element-120">
              Our asset labels are engineered to withstand the harshest
              industrial conditions. From extreme temperatures to chemical
              exposure, we guarantee readability for the lifespan of your
              assets.
            </p>

            <button className="px-7 py-3.5 bg-white text-[#0A1628] font-bold rounded-full hover:bg-slate-100 transition-colors flex items-center group" data-id="element-121">
              Explore asset labels
              <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" data-id="element-122" />
            </button>
          </motion.div>

          {/* Feature Grid */}
          <div className="grid grid-cols-2 gap-4" data-id="element-123">
            {[{
            icon: ShieldCheck,
            title: 'Chemical resistant',
            desc: 'Protected against solvents, oils, and cleaning agents.'
          }, {
            icon: Zap,
            title: 'Extreme temperature',
            desc: 'Rated for -40°C to +150°C operational ranges.'
          }, {
            icon: Layers,
            title: 'High-bond adhesives',
            desc: 'Specialised adhesives for textured surfaces.'
          }, {
            icon: PenTool,
            title: 'Custom fabrication',
            desc: 'Any size, shape, or material specification.'
          }].map((feature, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1 + i * 0.1
          }} className="bg-white/5 border border-white/10 p-5 rounded-xl" data-id="element-124">
                <feature.icon className="h-6 w-6 text-[#0052CC] mb-3" data-id="element-125" />
                <h3 className="text-white font-bold text-sm mb-1.5" data-id="element-126">
                  {feature.title}
                </h3>
                <p className="text-slate-400 text-xs leading-relaxed" data-id="element-127">
                  {feature.desc}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}